import Url from 'url'
import _ from 'lodash'
//TODO penguinのcallAPIとかのほうを使うようにしたいので消したい
const CSRF_TOKEN = getCSRFToken()

export function callAPIRaw(path: string, options = {}) {
  return fetch(endpoint(path), {
    ...options,
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': CSRF_TOKEN,
    },
  })
}

export function callAPI(path: string, options = {}) {
  return callAPIRaw(path, options)
    .then((res) => res.json())
    .then((payload) => ({ payload }))
    .catch((error) => ({ error }))
}

export function getBlob(path: string, options = {}) {
  return callAPIRaw(path, options)
    .then((res) => res.blob())
    .then((payload) => ({ payload }))
    .catch((error) => ({ error }))
}

export function href() {
  return typeof location !== 'undefined' ? location.href : ''
}

const ENDPOINT_BASE = ((url) => {
  const f = Url.parse(url)
  if (f.protocol && f.host) {
    return `${f.protocol}//${f.host}`
  } else {
    // NOTE: For testing purpose
    return 'http://localhost'
  }
})(href())

export function endpoint(path: string) {
  return `${ENDPOINT_BASE}${path}`
}

export function getCSRFToken() {
  // const meta = document.querySelector('meta[name="csrf-token"]');
  // if(!meta){
  //   return ''
  // }
  // return meta.getAttribute('content') || '';
  return ''
}
